type Roles = 'admin' | 'owner' | 'developer';

export let peopleWithRoles: Record<Roles, string[]> = {
	admin: ['Thuta Sann', 'Hsu Ye Ywel'],
	owner: ['Pyae Thuta'],
	developer: ['aung'],
};

// peopleWithRoles = {
// 	owner: ['hsu'],
// }; // <-- Error: `admin` and `developer` is missing

// --------
type PagesProps = Record<
	'home' | 'services' | 'about',
	{
		id: number;
		title: string;
		isActive: boolean;
	}
>;

export const Pages: PagesProps = {
	home: {
		id: 1,
		title: 'Home',
		isActive: true,
	},
	services: {
		id: 1,
		title: 'Services',
		isActive: true,
	},
	about: {
		id: 1,
		title: 'About',
		isActive: false,
	},
};
